// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageContentMain {
  height: calc(100vh - 41px);
  overflow: auto;
}

.page-title {
  padding: 5px 10px;
  font-size: 20px;
  color: #2a2e32;
}

.sub-title {
  padding: 5px 10px;
  font-size: 17px;
  color: #2a2e32;
}

.page-titleRow {
  float: left;
  width: 100%;
  background: #fff;
  box-shadow: 1px 1px 4px #e6e6e6;
}

.listvalues-lft .nav-pills .nav-link {
  font-size: 13px;
  color: #484b4e;
  padding: 8px 4px 8px 10px;
  border-radius: 0;
  border-bottom: 1px solid #e6e6e6;
}`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytic-builder/analytic-builder.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,cAAA;AACJ;;AAGA;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAGA;EACI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gCAAA;AACJ","sourcesContent":[".pageContentMain {\r\n    height: calc(100vh - 41px);\r\n    overflow: auto;\r\n    //margin-top: 41px;\r\n}\r\n\r\n.page-title {\r\n    padding: 5px 10px;\r\n    font-size: 20px;\r\n    color: #2a2e32;\r\n}\r\n\r\n.sub-title {\r\n    padding: 5px 10px;\r\n    font-size: 17px;\r\n    color: #2a2e32;\r\n}\r\n\r\n.page-titleRow {\r\n    float: left;\r\n    width: 100%;\r\n    background: #fff;\r\n    box-shadow: 1px 1px 4px #e6e6e6;\r\n}\r\n.listvalues-lft .nav-pills .nav-link {\r\n    font-size: 13px;\r\n    color: #484b4e;\r\n    padding: 8px 4px 8px 10px;\r\n    border-radius: 0;\r\n    border-bottom: 1px solid #e6e6e6;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
